import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import FAQ from '../FAQ';

const page = 'prequalified';
/* Strapi CMS Support Article URLs for Active Terms Page. Map type is used to preserve article order. */
const articleIds = new Map(
  [
    /* Does pre-qualifying mean I am fully approved for a Carvana auto loan? */
    'does-pre-qualifying-mean-i-am-fully-approved-for-a-carvana-auto-loan',
    /* What are the restrictions on adding a co-signer? */
    'what-are-the-restrictions-on-adding-a-co-signer',
    /* When is my down payment due? */
    'when-is-my-down-payment-due',
    /* Can I split my down payment into multiple payments? */
    'can-i-split-my-down-payment-into-multiple-payments',
    /* Does Carvana offer financing if I choose to purchase elsewhere? */
    'does-carvana-offer-financing-if-i-choose-to-purchase-elsewhere',
    /* If I get pre-qualified through Carvana, does it impact my credit? */
    'if-i-get-pre-qualified-through-carvana-does-it-impact-my-credit'
  ].map((id, idx) => [id, idx])
);

export default function PrequalFaq() {
  return (
    <Section
      className="bg-canvas-muted"
      eventName={ANALYTICS_EVENTS.PREQUALIFIED.SECTION_VIEWED_FAQ}
    >
      <FAQ page={page} urls={articleIds} />
    </Section>
  );
}
